<div class="row form-group">
  <div class="col-sm-4">
    <div class="row form-group">
      <label for="ano" class="col-sm-4 col-form-label font-weight-bold">EXERCÍCIO:</label>
      <div class="col-sm-5">
        <select #ano_ [(ngModel)]="anoCorrente" id="ano" class="form-control custom-select-sm font-weight-bold"
          (change)="alternarAno(ano_.value)">
          <option [value]="item.ano" *ngFor="let item of listaExercicios">
            {{item.ano}}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="row form-group">
  <div class="col-12">
    <table class="table table-bordered" style="font-size:14px">
      <thead>
        <tr>
          <th scope="col" class="text-center">Código</th>
          <th scope="col" class="text-center">Nome</th>
          <th scope="col" class="text-center">Unid.Medida</th>
          <th scope="col" class="text-center">Recente</th>
          <th scope="col" class="text-center">Futuro</th>
          <th scope="col" class="text-center">Meta Prevista</th>
          <th scope="col" class="text-center">Meta Realizada</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of listaIndicadores; let idx = index">
          <td class="text-center" style="width: 200px">{{item.codigo}}</td>
          <td class="text-left" style="width: 50%">{{item.nome}}</td>
          <td class="text-center" style="width: 300px">{{item.unidade_medida}}</td>
          <td class="text-center" style="width: 300px">{{item.recente | number:'1.2-2'}}</td>
          <td class="text-center" style="width: 350px">{{item.futuro | number:'1.2-2'}}</td>
          <td class="text-center" style="width: 350px" *ngIf="indice === 1">{{item.meta1 | number:'1.2-2'}}</td>
          <td class="text-center" style="width: 350px" *ngIf="indice === 2">{{item.meta2 | number:'1.2-2'}}</td>
          <td class="text-center" style="width: 350px" *ngIf="indice === 3">{{item.meta3 | number:'1.2-2'}}</td>
          <td class="text-center" style="width: 350px" *ngIf="indice === 4">{{item.meta4 | number:'1.2-2'}}</td>
          <td style="width: 200px; text-align: right;">
            <p-inplace>
              <span pInplaceDisplay>
                <span *ngIf="indice === 1">{{item.meta_realizada1 | number:'1.2-2'}}</span>
                <span *ngIf="indice === 2">{{item.meta_realizada2 | number:'1.2-2'}}</span>
                <span *ngIf="indice === 3">{{item.meta_realizada3 | number:'1.2-2'}}</span>
                <span *ngIf="indice === 4">{{item.meta_realizada4 | number:'1.2-2'}}</span>
              </span>
              <span pInplaceContent>
                <input *ngIf="indice === 1" type="text" [(ngModel)]="item.meta_realizada1"
                  [ngModelOptions]="{standalone: true}" unmask="true" [imask]="imaskConfig" (blur)="salvar(item)"
                  class="form-control form-control-sm text-right">
                <input *ngIf="indice === 2" type="text" [(ngModel)]="item.meta_realizada2"
                  [ngModelOptions]="{standalone: true}" unmask="true" [imask]="imaskConfig" (blur)="salvar(item)"
                  class="form-control form-control-sm text-right">
                <input *ngIf="indice === 3" type="text" [(ngModel)]="item.meta_realizada3"
                  [ngModelOptions]="{standalone: true}" unmask="true" [imask]="imaskConfig" (blur)="salvar(item)"
                  class="form-control form-control-sm text-right">
                <input *ngIf="indice === 4" type="text" [(ngModel)]="item.meta_realizada4"
                  [ngModelOptions]="{standalone: true}" unmask="true" [imask]="imaskConfig" (blur)="salvar(item)"
                  class="form-control form-control-sm text-right">
              </span>
            </p-inplace>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
